// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

/* eslint-disable */

import * as _ from "lodash";
import * as React from "react";
import { XMLParser } from "fast-xml-parser";
import Slider from "react-slick";
import "./Actualites.less";
import { publicApi } from "../../../../api";
import { jsx as _jsx } from "react/jsx-runtime";
const Slide = ({
  image,
  link,
  title
}) => /*#__PURE__*/_jsx("a", {
  href: link,
  target: "_blank",
  rel: "noopener noreferrer",
  style: {
    backgroundImage: `url(${image})`
  },
  "data-sentry-component": "Slide",
  "data-sentry-source-file": "Actualites.tsx",
  children: /*#__PURE__*/_jsx("span", {
    children: title
  })
});
const Actualites = () => {
  const [items, setItems] = React.useState([]);
  React.useEffect(() => {
    publicApi.get("/api?url=https://www.jvs-mairistem.fr/feed/rss.xml").then(data => {
      const xml = new XMLParser({
        attributeNamePrefix: "",
        textNodeName: "$text",
        ignoreAttributes: false
      });
      const result = xml.parse(data);

      // @ts-ignore
      let channel = result.rss?.channel ? result.rss.channel : result.feed;
      if (Array.isArray(channel)) channel = channel[0];
      const rss = {
        title: channel.title ?? "",
        description: channel.description ?? "",
        link: channel.link?.href ? channel.link.href : channel.link,
        image: channel.image ? channel.image.url : channel["itunes:image"] ? channel["itunes:image"].href : "",
        category: channel.category || [],
        items: []
      };
      let items = channel.item || channel.entry || [];
      if (items && !Array.isArray(items)) items = [items];
      for (let i = 0; i < items.length; i++) {
        const val = items[i];
        const media = {};
        const obj = {
          id: val.guid?.$text ? val.guid.$text : val.id,
          title: val.title?.$text ? val.title.$text : val.title,
          description: val.summary?.$text ? val.summary.$text : val.description,
          link: val.link?.href ? val.link.href : val.link,
          author: val.author?.name ? val.author.name : val["dc:creator"],
          published: val.created ? Date.parse(val.created) : val.pubDate ? Date.parse(val.pubDate) : Date.now(),
          created: val.updated ? Date.parse(val.updated) : val.pubDate ? Date.parse(val.pubDate) : val.created ? Date.parse(val.created) : Date.now(),
          category: val.category || [],
          content: val.content?.$text ? val.content.$text : val["content:encoded"],
          enclosures: val.enclosure ? Array.isArray(val.enclosure) ? val.enclosure : [val.enclosure] : []
        };
        ["content:encoded", "podcast:transcript", "itunes:summary", "itunes:author", "itunes:explicit", "itunes:duration", "itunes:season", "itunes:episode", "itunes:episodeType", "itunes:image"].forEach(s => {
          if (val[s]) obj[s.replace(":", "_")] = val[s];
        });
        if (val["media:thumbnail"]) {
          Object.assign(media, {
            thumbnail: val["media:thumbnail"]
          });
          obj.enclosures.push(val["media:thumbnail"]);
        }
        if (val["media:content"]) {
          Object.assign(media, {
            thumbnail: val["media:content"]
          });
          obj.enclosures.push(val["media:content"]);
        }
        if (val["media:group"]) {
          if (val["media:group"]["media:title"]) obj.title = val["media:group"]["media:title"];
          if (val["media:group"]["media:description"]) obj.description = val["media:group"]["media:description"];
          if (val["media:group"]["media:thumbnail"]) obj.enclosures.push(val["media:group"]["media:thumbnail"].url);
        }
        Object.assign(obj, {
          media
        });
        rss.items.push(obj);
      }
      return rss;
    }).then(({
      items
    }) => setItems(_.map(items, item => {
      const parser = new DOMParser();
      const htmlDoc = parser.parseFromString(item.description, "text/html");
      const descriptionTags = htmlDoc.getElementsByTagName("p");
      const description = !_.isEmpty(descriptionTags) && descriptionTags.length > 0 ? descriptionTags[0].innerText : "";
      const imageTags = htmlDoc.getElementsByTagName("img");
      const image = !_.isEmpty(imageTags) && imageTags.length > 0 ? `${_.replace(htmlDoc.getElementsByTagName("img")[0].getAttribute("src"), "w250", "w500xh350")}` : null;
      return {
        title: item.title,
        description,
        image,
        link: item.link
      };
    })));
  }, []);
  return /*#__PURE__*/_jsx(Slider, {
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    "data-sentry-element": "Slider",
    "data-sentry-component": "Actualites",
    "data-sentry-source-file": "Actualites.tsx",
    children: _.map(items, item => /*#__PURE__*/_jsx(Slide, {
      ...item
    }, item.link))
  });
};
export default Actualites;